/* c8 ignore start */

import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const ReportManagerModule = ({ registerNavItems }) => {
  // Routes are registered via central router bundles
  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { ReportManagerModule };

export default {};
/* c8 ignore end */
